import * as actionTypes from './redux.actionTypes';
import { DEFAULT_PAGE_SIZE } from './common';

const initialState = {
    goals: [],
    selectedGoal: null,
    loading: false,
    error: null,
    
    // Departments
    departments: [],
    departmentsLoading: false,
    departmentsError: null,
    
    // Pagination
    pagination: {
        limit: DEFAULT_PAGE_SIZE,
        offset: 1,
        total: 0
    },
    
    // Filters
    filters: {
        search: '',
        complexity: '',
        departmentId: ''
    },
    
    // Sorting
    sort: {
        sortBy: 'createdAt',
        sortDescending: false
    },
    
    // Dialog states
    isGoalDialogOpen: false,
    isDeleteDialogOpen: false,
    isGoalUsageDialogOpen: false,
    goalUsageData: null
};

const goalReducer = (state = initialState, action) => {
    switch (action.type) {
        // Fetch goals
        case actionTypes.FETCH_GOALS:
            return {
                ...state,
                loading: true,
                error: null
            };
        
        case actionTypes.FETCH_GOALS_SUCCESS:
            return {
                ...state,
                loading: false,
                goals: action.payload.data || [],
                pagination: {
                    ...state.pagination,
                    total: action.payload.total || 0
                }
            };
        
        case actionTypes.FETCH_GOALS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        
        // Fetch goal by ID
        case actionTypes.FETCH_GOAL_BY_ID:
            return {
                ...state,
                loading: true,
                error: null
            };
        
        case actionTypes.FETCH_GOAL_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedGoal: action.payload
            };
        
        case actionTypes.FETCH_GOAL_BY_ID_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        
        // Create goal
        case actionTypes.CREATE_GOAL:
            return {
                ...state,
                loading: true,
                error: null
            };
        
        case actionTypes.CREATE_GOAL_SUCCESS:
            return {
                ...state,
                loading: false,
                goals: [action.payload, ...state.goals]
            };
        
        case actionTypes.CREATE_GOAL_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        
        // Update goal
        case actionTypes.UPDATE_GOAL:
            return {
                ...state,
                loading: true,
                error: null
            };
        
        case actionTypes.UPDATE_GOAL_SUCCESS:
            return {
                ...state,
                loading: false,
                goals: state.goals.map((goal) =>
                    goal.id === action.payload.id ? action.payload : goal
                )
            };
        
        case actionTypes.UPDATE_GOAL_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        
        // Delete goal
        case actionTypes.DELETE_GOAL:
            return {
                ...state,
                loading: true,
                error: null
            };
        
        case actionTypes.DELETE_GOAL_SUCCESS:
            return {
                ...state,
                loading: false,
                goals: state.goals.filter((goal) => goal.id !== action.payload.id)
            };
        
        case actionTypes.DELETE_GOAL_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        
        // Dialog management
        case actionTypes.OPEN_GOAL_DIALOG:
            return {
                ...state,
                isGoalDialogOpen: true,
                selectedGoal: action.payload
            };
        
        case actionTypes.CLOSE_GOAL_DIALOG:
            return {
                ...state,
                isGoalDialogOpen: false,
                selectedGoal: null
            };
        
        case actionTypes.OPEN_DELETE_DIALOG:
            return {
                ...state,
                isDeleteDialogOpen: true,
                selectedGoal: action.payload
            };
        
        case actionTypes.CLOSE_DELETE_DIALOG:
            return {
                ...state,
                isDeleteDialogOpen: false,
                selectedGoal: null
            };
        
        // Set selected goal
        case actionTypes.SET_SELECTED_GOAL:
            return {
                ...state,
                selectedGoal: action.payload
            };
        
        // Set filters
        case actionTypes.SET_FILTERS:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload
                }
            };
        
        // Set pagination
        case actionTypes.SET_PAGINATION:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.payload
                }
            };
        
        // Set sort
        case actionTypes.SET_SORT:
            return {
                ...state,
                sort: {
                    ...state.sort,
                    ...action.payload
                }
            };
        
        // Goal usage dialog
        case actionTypes.OPEN_GOAL_USAGE_DIALOG:
            return {
                ...state,
                isGoalUsageDialogOpen: true,
                goalUsageData: action.payload
            };
        
        case actionTypes.CLOSE_GOAL_USAGE_DIALOG:
            return {
                ...state,
                isGoalUsageDialogOpen: false,
                goalUsageData: null
            };
        
        // Fetch departments
        case actionTypes.FETCH_DEPARTMENTS:
            return {
                ...state,
                departmentsLoading: true,
                departmentsError: null
            };
        
        case actionTypes.FETCH_DEPARTMENTS_SUCCESS:
            return {
                ...state,
                departmentsLoading: false,
                departments: Array.isArray(action.payload) ? action.payload : []
            };
        
        case actionTypes.FETCH_DEPARTMENTS_FAILURE:
            return {
                ...state,
                departmentsLoading: false,
                departmentsError: action.payload
            };
        
        default:
            return state;
    }
};

export default goalReducer;
